<template>
<v-card flat >

  <!-- <v-card-title class="overline grey lighten-4 py-1" >Choose a practitioner:</v-card-title>
  <v-divider/> -->
  <!-- <practitioner-picker v-model="local.practitioner" /> -->

  <v-card flat >

    <v-card-title class="overline grey lighten-4 py-1" >Choose a practitioner:</v-card-title>
    <template v-for="(practitioner) in getColleagues" >
      <!-- <pre v-text="mem" class="caption" :key="`p-${mem.id}`" /> -->
      <v-chip
        v-if="practitioner.is_active"
        @click="local.practitioner=practitioner"
        :key="practitioner.id"
        :class="{'info white--text': idsAreEqual(practitioner.id, practitionerId) }" >
        <v-icon left v-if="idsAreEqual(practitioner.id, practitionerId)"  >check</v-icon>
        {{practitioner.full_name}}
      </v-chip>
      <!-- <pre v-text="practitioner" class="caption" /> -->
    </template>

  </v-card>

  <v-card flat v-if="practitionerId" >
    <v-card-title class="overline grey lighten-4 py-1" >Choose a space:</v-card-title>
    <template v-for="mem in local.practitioner.memberships" >
      <!-- <pre v-text="mem" class="caption" :key="`p-${mem.id}`" /> -->
      <v-chip
        @click="local.space=mem.service_data"
        :key="mem.id" v-if="mem.is_active"
        :class="{'info white--text': idsAreEqual(mem.service, spaceId) }" >
        <v-icon left v-if="idsAreEqual(mem.service, spaceId)"  >check</v-icon>
        {{mem.space_name}}
      </v-chip>
    </template>
  </v-card>
  <!-- <pre v-text="local.practitioner" class="caption" /> -->

  <v-card flat v-if="practitionerId && spaceId" >
    <v-card-title class="overline grey lighten-4 py-1" >Choose an appointment type:</v-card-title>
    <template v-for="product in products" >
      <!-- <pre v-text="product" class="caption" :key="`p-${product.id}`" /> -->
      <v-chip :key="product.id"
        @click="local.product=product"
        :class="{'info white--text': idsAreEqual(local.product.id, product.id) }" >
        <v-icon left v-if="idsAreEqual(local.product.id, product.id)"  >check</v-icon>
        {{product.title}}
      </v-chip>
    </template>
  </v-card>

  <v-card flat v-if="productId && local.product.locations && local.product.locations.length > 0" >
    <v-card-title class="overline grey lighten-4 py-1" >Choose a location:</v-card-title>
    <template v-for="location in local.product.locations" >
      <!-- <pre v-text="product" class="caption" :key="`p-${product.id}`" /> -->
      <v-chip :key="`${location.id}-${productId}`"
        @click="local.location=location"
        :class="{'info white--text': idsAreEqual(location.id, local.location.id) }" >
        <v-icon left v-if="idsAreEqual(location.id, local.location.id)"  >check</v-icon>
        {{location.name}}
      </v-chip>
    </template>
  </v-card>

  <!-- <pre v-text="local.product" class="caption" /> -->
</v-card>
</template>
<script>
import PractitionerPicker from '@/components/pickers/PractitionerPicker.vue'
import AppointmentType from '@/components/pages/settings/locations/AppointmentTypes'
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  name: 'PractitionerProductSheet',
  components: {
    PractitionerPicker,
    AppointmentType
  },
  props: {
    space: { type: Object },
    practitioner: { type: Object },
    product: { type: Object },
    location: { type: Object }
  },
  data () {
    return {
      local: {
        practitioner: { id: null },
        space: { id: null },
        product: { id: null },
        location: { id: null }
      }
    }
  },
  watch: {
    // practitioner: {
    //   immediate: true,
    //   handler () {
    //     if (this.practitioner && this.practitioner.id) {
    //       Vue.set(this.local, 'practitioner', this.practitioner)
    //     }
    //   }
    // },
    locationId () {
      this.$emit('update:location', this.local.location)
    },
    productId () {
      this.$emit('update:product', this.local.product)
      Vue.set(this.local, 'location', {id: null})
      console.log('productid')
    },
    spaceId () {
      this.$emit('update:space', this.local.space)
      Vue.set(this.local, 'product', {id: null})
    },
    practitionerId () {
      this.space = {id: null}
      this.$emit('update:practitioner', this.local.practitioner)
      Vue.set(this.local, 'space', {id: null})
    }
  },
  computed: {
    ...mapGetters(['lookups', 'getColleagues']),
    practitionerId () {
      return this.getObjectPath(this.local, 'practitioner.id')
    },
    spaceId () {
      return this.getObjectPath(this.local, 'space.id')
    },
    productId () {
      return this.getObjectPath(this.local, 'product.id')
    },
    locationId () {
      return this.getObjectPath(this.local, 'location.id')
    },
    colleagues () {
      let colleagues = this.getColleagues
      if (colleagues) {
        return Object.values(colleagues)
      }
      return []
    },
    products () {
      let p = this.getObjectPath(this.lookups, 'products', [])
      console.log(this.practitionerId, this.spaceId)
      if (p) {
        let productList = Object.values(p)
        let filtered = productList.filter((prod) => {
          if (this.practitionerId && !this.idsAreEqual(this.practitionerId, prod.owner)) {
            return null
          }
          if (this.spaceId && !this.idsAreEqual(this.spaceId, prod.space)) {
            return null
          }
          return prod
        })
        return filtered
      }
      return p
    }
  }
}
</script>



// WEBPACK FOOTER //
// PractitionerProductPicker.vue?68647663